import { combineReducers } from "redux";
import authReducer from "./authReducer";
import messageReducer from "./messageReducer";
import profileReducer from "./profileReducer";

const reducers = combineReducers({
    profile: profileReducer,
    auth: authReducer,
    message: messageReducer
});

export default reducers;